import * as React from 'react';
const SvgDocusign = (props) => (
  <svg
    width={20}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.5} y={0.5} width={19} height={19} rx={5.5} stroke="#E9EBF4" />
    <path
      d="M12.3675 12.3647V15.1125C12.3675 15.2568 12.2509 15.3734 12.1066 15.3734H4.88474C4.74041 15.3734 4.62384 15.2568 4.62384 15.1125V7.89617C4.62384 7.75185 4.74041 7.63527 4.88474 7.63527H7.62694V12.1038C7.62694 12.2482 7.74351 12.3647 7.88784 12.3647H12.3675Z"
      fill="#4C00FF"
    />
    <path
      d="M15.3762 8.49013C15.3762 10.7994 14.0273 12.3592 12.3675 12.3647V9.45601C12.3675 9.37274 12.3342 9.28948 12.2731 9.23397L10.7633 7.72409C10.7022 7.66303 10.6245 7.62972 10.5412 7.62972H7.63249V4.88752C7.63249 4.7432 7.74906 4.62662 7.89339 4.62662H11.9623C13.894 4.62107 15.3762 6.17536 15.3762 8.49013Z"
      fill="#FF5252"
    />
    <path
      d="M12.2731 9.22842C12.3342 9.28948 12.3675 9.36719 12.3675 9.45046V12.3592H7.89339C7.74906 12.3592 7.63249 12.2426 7.63249 12.0983V7.62972H10.5412C10.6245 7.62972 10.7078 7.66303 10.7633 7.72409L12.2731 9.22842Z"
      fill="black"
    />
  </svg>
);
export default SvgDocusign;
